import {openPanel} from '../sidePanel-action'

import './slideRight'

export function slideFromRight(containerId, data, className=false) {
    return openPanel(containerId, data, 'sidePanel-slideRight' + (className ? ' ' + className : ''))
}

/**
 * @deprecated
 */
export const sidePanelSlideFromRight = slideFromRight
